export function frameTimePeriod(ExtractSelection, yrs) {
    let timePeriodOptionsForFolder = [
        'Latest 1 Week',
        'Latest 4 Weeks',
        'Latest 12 Weeks',
        'Latest 13 Weeks',
        'Latest 26 Weeks',
        'Latest 52 Weeks',
        'Year to Date',
    ];
    let timePeriodOptionsForPreviousFolder = [
        'Previous 1 Week',
        'Previous 4 Weeks',
        'Previous 12 Weeks',
        'Previous 13 Weeks',
        'Previous 26 Weeks',
        'Previous 52 Weeks',
    ];
    let folderValues: string[] = [];
    let previousFolderValues: string[] = [];
    for (let index = 0; index < yrs; index++) {
        timePeriodOptionsForFolder.map((val) => {
            if (index === 0) {
                folderValues.push(val);
            } else if (index === 1) {
                folderValues.push(`${val} Year-Ago`);
            } else {
                folderValues.push(`${val} ${index}-Year-Ago`);
            }
            return folderValues;
        });

        timePeriodOptionsForPreviousFolder.map((val) => {
            if (index === 0) {
                previousFolderValues.push(val);
            } else if (index === 1) {
                previousFolderValues.push(`${val} Year-Ago`);
            } else {
                previousFolderValues.push(`${val} ${index}-Year-Ago`);
            }
            return previousFolderValues;
        });
    }
    timePeriodOptionsForFolder = folderValues.length > 0 ? folderValues : timePeriodOptionsForFolder;
    timePeriodOptionsForPreviousFolder = previousFolderValues.length > 0 ? previousFolderValues : timePeriodOptionsForPreviousFolder;
    return (
        (ExtractSelection?.timePeriods?.data || ExtractSelection?.timePeriods)
            ?.map((item) => {
                if (item) {
                    const type = item?.folder?.value || item?.type;
                    switch (type) {
                        case 'Periods ending latest week':
                            return item.selections
                                ?.filter((val) => val !== 'all')
                                .sort(
                                    (a, b) =>
                                        timePeriodOptionsForFolder.indexOf(a) - timePeriodOptionsForFolder.indexOf(b)
                                );
                        case 'Periods ending previous week':
                            return item.selections
                                ?.filter((val) => val !== 'all')
                                .sort(
                                    (a, b) =>
                                        timePeriodOptionsForPreviousFolder.indexOf(a) - timePeriodOptionsForPreviousFolder.indexOf(b)
                                );
                        case 'Weeks':
                            return item.selections
                                ?.filter((val) => val !== 'all')
                                .sort(
                                    (a, b) =>
                                        new Date(
                                            parseInt(b.split('-')[2]),
                                            parseInt(b.split('-')[0]) - 1,
                                            parseInt(b.split('-')[1])
                                        ).getTime() -
                                        new Date(
                                            parseInt(a.split('-')[2]),
                                            parseInt(a.split('-')[0]) - 1,
                                            parseInt(a.split('-')[1])
                                        ).getTime()
                                )
                                .map((item) => {
                                    return `1 Week - W/E ${item}`;
                                });
                        case '4 Weeks':
                            return item.selections
                                ?.filter((val) => val !== 'all')
                                .sort(
                                    (a, b) =>
                                        new Date(
                                            parseInt(b.split('-')[2]),
                                            parseInt(b.split('-')[0]) - 1,
                                            parseInt(b.split('-')[1])
                                        ).getTime() -
                                        new Date(
                                            parseInt(a.split('-')[2]),
                                            parseInt(a.split('-')[0]) - 1,
                                            parseInt(a.split('-')[1])
                                        ).getTime()
                                )
                                .map((item) => {
                                    return `4 Wks - W/E ${item}`;
                                });
                        case 'Months':
                            const monthNames = [
                                'January',
                                'February',
                                'March',
                                'April',
                                'May',
                                'June',
                                'July',
                                'August',
                                'September',
                                'October',
                                'November',
                                'December',
                            ];
                            return item.selections
                                ?.filter((val) => val !== 'all')
                                .sort(
                                    (a, b) =>
                                        new Date(
                                            parseInt(b.split('-')[2]),
                                            parseInt(b.split('-')[0]) - 1,
                                            parseInt(b.split('-')[1])
                                        ).getTime() -
                                        new Date(
                                            parseInt(a.split('-')[2]),
                                            parseInt(a.split('-')[0]) - 1,
                                            parseInt(a.split('-')[1])
                                        ).getTime()
                                )
                                .map((date) => {
                                    const refDate = new Date(
                                        parseInt(date.split('-')[2]),
                                        parseInt(date.split('-')[0]) - 1,
                                        parseInt(date.split('-')[1])
                                    );
                                    refDate.setDate(refDate.getDate() - 7);
                                    return `${monthNames[refDate.getMonth()]} ${refDate.getFullYear()} - W/E ${date}`;
                                });
                        case 'Quarters':
                            return item.selections
                                ?.filter((val) => val !== 'all')
                                .sort(
                                    (a, b) =>
                                        new Date(
                                            parseInt(b.split('-')[2]),
                                            parseInt(b.split('-')[0]) - 1,
                                            parseInt(b.split('-')[1])
                                        ).getTime() -
                                        new Date(
                                            parseInt(a.split('-')[2]),
                                            parseInt(a.split('-')[0]) - 1,
                                            parseInt(a.split('-')[1])
                                        ).getTime()
                                )
                                .map((item) => {
                                    return `Quarter - W/E ${item}`;
                                });
                        case 'Custom Time Period':
                            return item.selections
                                ?.sort(
                                    (a, b) =>
                                        new Date(
                                            parseInt(b.split('-')[2]),
                                            parseInt(b.split('-')[0]) - 1,
                                            parseInt(b.split('-')[1])
                                        ).getTime() -
                                        new Date(
                                            parseInt(a.split('-')[2]),
                                            parseInt(a.split('-')[0]) - 1,
                                            parseInt(a.split('-')[1])
                                        ).getTime()
                                )
                                .map((date) => {
                                    return `Custom ${item?.config?.period + ' Week' || 'Time'} - W/E ${date}`;
                                });
                        default:
                            //Years
                            return item.selections
                                ?.filter((val) => val !== 'all')
                                .sort(
                                    (a, b) =>
                                        new Date(
                                            parseInt(b.split('-')[2]),
                                            parseInt(b.split('-')[0]) - 1,
                                            parseInt(b.split('-')[1])
                                        ).getTime() -
                                        new Date(
                                            parseInt(a.split('-')[2]),
                                            parseInt(a.split('-')[0]) - 1,
                                            parseInt(a.split('-')[1])
                                        ).getTime()
                                )
                                .map((item) => {
                                    const dateObj = new Date(item);
                                    const day = dateObj.getDate();
                                    let year = dateObj.getFullYear();
                                    if (day <= 3) {
                                        year = year - 1;
                                    }
                                    return `Year ${year} - W/E ${item}`;
                                });
                    }
                }
                return null;
            })
            .filter((val) => val)
            .flat(Infinity)
            .filter((val) => val !== 'all') ?? []
    ).concat(
            ExtractSelection?.timePeriods?.summedPeriods?.map((item) => {
                return item.name;
            }) ?? []
        ).flat(Infinity);
}
